export enum ChatEnum {
  api_portal_chatreferencedata = '/apirest/portal/chat/referencedata',
  api_portal_chattopics = '/apirest/portal/chat/topics',
  api_portal_chattopicadd = '/apirest/portal/chat/topic/add',
  api_portal_chatmessagetextadd = '/apirest/portal/chat/message/text/add',
  api_portal_chatmeetingadd = '/apirest/portal/chat/message/meeting/add',
  api_portal_chattopicmesages = '/apirest/portal/chat/topic/{0}/mesages/{1}/{2}',
  api_portal_chatmessagetextmessageidreaded = '/apirest/portal/chat/message/text/{0}/readed',
  api_portal_chatmessagedocadd = '/apirest/portal/chat/message/doc/add',
  api_portal_chatmessagedoc = '/apirest/portal/chat/message/doc/{0}',
  api_portal_chattopicidmessagetextreaded = '/apirest/portal/chat/{0}/message/text/readed',
  api_portal_subscribesse = '/apirest/portal/chat/sse/subscribe',
}

export enum NotificationsEnum {
  api_portal_client_notifications = '/apirest/portal/client/notifications/{0}/{1}',
  api_portal_client_notification_idread = '/apirest/portal/client/notifications/{0}/read',
  api_portal_client_notifications_read = '/apirest/portal/client/notifications/read',
}

export enum ActivitiesEnum {
  api_portal_get_activities = '/apirest/portal/portfolio/{0}/activity/{1}/{2}',
  api_portal_get_activities_orders = '/apirest/portal/portfolio/{0}/activity/{1}/orders',
  api_activities_contribution_delete = '/apirest/portal/portfolio/{0}/activity/contribution/{1}',
  api_activities_withdrawal_delete = '/apirest/portal/portfolio/{0}/activity/withdrawal/{1}',
}

export enum QuestionnaireEnum {
  api_questionnaire_get_investor_profile = '/apirest/portal/questionnaire/investorprofile/{0}',
  api_questionnaire_get_investment_profile = '/apirest/portal/questionnaire/investmentprofile/{0}',
  api_questionnaire_evaluate_profile = '/apirest/portal/questionnaire/evaluateprofile',
  api_questionnaire_extendedtest = '/apirest/portal/A297/extendedtest/{0}',
  api_questionnaire_get_ServiceModelPortfolio = '/apirest/portal/modelportfolio/servicemodel/{0}',
  api_questionnaire_set_signature = '/apirest/portal/portfolio/{0}/modelportfolio',
}

export enum OperativeEnum {
  api_operative_get_type_contribution = '/apirest/portal/contribution/enumeration/{0}',
  api_operative_get_fund_location = '/apirest/portal/enumeration/FundLocation',
  api_operative_get_type_withdrawal = '/apirest/portal/withdrawal/enumeration',
  api_operative_get_portfolio = '/apirest/portal/portfolio/{0}',
  api_operative_get_modelportfolio = '/apirest/portal/modelportfolio/{0}',
  api_operative_get_servicemodels = '/apirest/portal/servicemodels/{0}',
  api_operative_sendcontribution = '/apirest/portal/portfolio/{0}/activity/contribution',
  api_operative_sendwithdrawal = '/apirest/portal/portfolio/{0}/activity/withdrawal',
  api_operative_sms_validation_contribution = '/apirest/portal/portfolio/{0}/activity/contribution/{1}/activate',
  api_operative_sms_validation_withdrawal = '/apirest/portal/portfolio/{0}/activity/withdrawal/{1}/activate',
  api_operative_sms_resend = '/apirest/portal/portfolio/{0}/activity/{1}/resend',
}

export enum CommonEnum {
  api_common_getuserbusinessarea = '/api/common/get_userbusinessarea',
  get_client_data = '/api/client/get_clientdata',
  apirest_get_client_data = '/apirest/portal/client',
  automatic_login = '/apirest/portal/login/{0}/{1}',
  bussinesarea_data = '/apirest/common/bussinesarea/{0}',
  logout_client = '/apirest/portal/logout',
  api_custodian_client = '/apirest/portal/custodian/client',
}

export enum CompleteDataEnum {
  apirest_get_enumeration = '/apirest/portal/enumeration/{0}',
  apirest_get_enumeration2 = '/apirest/portal/enumeration/{0}/{1}',
  apirest_full_client_data = '/apirest/portal/onboarding/client/data',
  apirest_get_what_legaldocuments = '/apirest/portal/client/legaldocuments',
  apirest_upload_document = '/apirest/portal/client/document',
  apirest_upload_document_proofAddress = '/apirest/portal/client/proofofaddress',
  apirest_set_step = '/apirest/portal/portfolio/{0}/onboarding/step',
  apirest_get_custodio_doc = '/apirest/portal/onboarding/custodian/{0}/document',
  apirest_get_custodio_doc2 = '/apirest/portal/onboarding/custodian/{0}/document/{1}',
  apirest_finalize_onboarding = '/apirest/portal/portfolio/{0}/onboarding',
  apirest_get_portfolio_data = '/apirest/portal/portfolio/{0}',
  apirest_get_contract_doc = '/apirest/portal/onboarding/portfolio/{0}/contract',
  apirest_get_exoneration_doc = '/apirest/portal/onboarding/portfolio/{0}/exoneration ',
  apirest_get_pendingtask_ib = '/apirest/portal/portfolio/{0}/pendingtaskib',
  apirest_get_portfolio_sign = '/apirest/portal/onboarding/portfolio/{0}/sign',
}

export enum ProfilePortfolioEnum {
  get_portfolios = '/api/client/get_clientportfolios',
  get_portfolioData = '/apirest/portal/portfolio/{0}',
  get_portfolioanalysis = '/apirest/portal/portfolio/get_portfolioanalysis',
  get_fixedperiods = '/apirest/portal/portfolio/{0}/periods',
  get_portfolioPdfUrlReport = '/apirest/portal/portfolio/{0}/urlpdf/{1}/{2}',
  update_alias_contract = '/apirest/portal/portfolio/{0}/alias',
  apirest_get_portfolios = '/apirest/portal/client/portfolio',
  get_portfolioDiscretePerformance = '/apirest/portal/portfolio/{0}/discreteperformance/{1}/{2}', //{0}:{portfolioCode}, {1}:{calcType}, {2}:{period}
}

export enum DocManagerEnum {
  get_manualdocuments = '/apirest/portal/client/manualdocument', //Se cambio el dia 28 Agosto manualdocuments por manualdocument
  get_manualdocument_refdata = '/apirest/portal/client/manualdocument/refdata', //Se cambio el dia 29 Agosto manualdocuments por manualdocument
  get_manualdocumentfile = '/apirest/portal/client/manualdocument/{0}/download',
  get_accountstatementsdocument = '/apirest/portal/client/accountstatementsdocument', //clientcode
  get_accountstatementdocuments = '/apirest/portal/portfolio/{0}/accountstatementdocuments', //portfolioCode

  //Tipo Reports
  get_sheduledreports = '/apirest/portal/client/scheduledreport',
  get_massivereport = '/apirest/portal/client/massivereport',
  //Tipo Documentos firmados
  get_signeddocuments = '/apirest/portal/client/signeddocuments',
  get_othersdocuments = '/apirest/portal/client/othersdocuments',

  //Descarga
  get_documentshedulereport = '/apirest/portal/client/scheduledreport/{0}', //{scheduledreportid},
  get_documentmassivereport = '/apirest/portal/client/massivereport/{0}', //{massivereportid}'
  get_document1 = '/apirest/portal/client/document/{0}', //documentid //Para el nuevo Estado de cuenta
  get_document2 = '/apirest/portal/portfolio/{0}/document/{1}', //portfoliocode - documentid
}

export enum OnboardingCoreEnum {
  apirest_checkMail = '/apirest/onboarding/client',
  createaccount = '/apirest/onboarding',
  createaccount2 = '/apirest/onboarding/true',
  activatebysms = '/apirest/onboarding/activatebysms/{0}/{1}',
  resendsms = '/apirest/onboarding/resendsms/{0}',
  activatebymail = '/apirest/onboarding/activatebyemail/{0}/{1}',
  resendmail = '/apirest/onboarding/resendemail/{0}',
}

export enum PublicPlannerEnum {
  //FinnancialPlanningEnum = InitContributionEnum
  apirest_profile_analysis = '/apirest/portal/eval/{0}/{1}/analysis?amount={2} ',
  apirest_eval_refdata = '/apirest/portal/eval/referencedata',
  apirest_eval = '/apirest/portal/eval/goal',
  apirest_fees = '/apirest/portal/eval/{0}/{1}/fees',
  apirest_riskprofile = '/apirest/portal/eval/{0}/riskprofile ',
  apirest_goal = '/apirest/portal/client/goal',
  apirest_goal_portfolio = '/apirest/portal/client/goal/{0}/portfolio',
  apirest_funding = '/apirest/portal/portfolio/{0}/funding',
  apirest_currencies = '/apirest/portal/common/currency',
  apirest_modelportfolio = '/apirest/portal/modelportfolio/{0}',
  apirest_modelportfolio_servicemodel = '/apirest/portal/modelportfolio/servicemodel/{0}/{1}',
}

export enum LoginEnum {
  activateaccount = '/apirest/onboarding/{0}',
  client_modifypassword = '/apirest/portal/changepassword/{0}',
  client_validatetokenmodifypassword = '/api/Login/client_validatetokenmodifypassword?ta={0}',
  user_sendresetpassmailclient = '/apirest/portal/resetpass/{0}',
  apirest_client_login = '/apirest/portal/login',
  validation_login_client = '/api/login/client_login',
  register = '/apirest/portal/register',
}

export enum AccountSettings {
  apirest_client_bussinesareacode = '/apirest/portal/bussinesarea/{0}',
  apirest_client_language = '/apirest/portal/client/language',
  apirest_client_marketing = '/apirest/portal/client/marketing',
  apirest_user_changepassword = '/apirest/portal/user/changepassword',
}

export enum AccountCancelEnum {
  apirest_accountcancel_cancelrequest = '/apirest/portal/client/portfolio/{0}/cancelrequest',
  apirest_accountcancel_otp = '/apirest/portal/client/portfolio/{0}/cancelrequest/{1}/otp',
  apirest_accountcancel_verification = '/apirest/portal/client/portfolio/{0}/cancelrequest/{1}',
}

export enum EditDataEnum {
  client_edit_data = '/apirest/portal/client/data',
}

export enum OnboardingEnum {
  onboarding_pendingsection = '/apirest/portal/client/onboarding/pendingsection',
  onboarding_legaldocuments = '/apirest/portal/onboarding/legaldocuments/{0}',
}

export enum PortfoliosEnum {
  api_portal_client_servicemodel = '/apirest/portal/client/servicemodel',
  api_onboarding_client_portfolio = '/apirest/portal/onboarding/client/portfolio',
  api_onboarding_portfolio_onboarding = '/apirest/portal/portfolio/{0}/onboarding',
}

export enum AssetAdvancedSearchServiceEnum {
  apirest_asset_search_refdata = '/apirest/portal/asset/search/refdata',
  apirest_asset_advanced_search = '/apirest/portal/asset/advanced/search',
}

export enum modelportfolioThemesServiceEnum {
  apirest_modelportfolio_groups = '/apirest/portal/modelportfolio/group',
  apirest_modelportfolio_group = '/apirest/portal/modelportfolio/group/{0}',
}

export enum LaboratoryServiceEnum {
  apirest_portal_assetrecom_criterias = '/apirest/portal/assetrecom/criterias',
  apirest_portal_assetrecom_by_code_value = '/apirest/portal/assetrecom/{0}/{1}/assets',
  apirest_portal_assetrecom_favourite_add = '/apirest/portal/assetrecom/favourite/{0}/add',
  apirest_portal_assetrecom_favourite_delete = '/apirest/portal/assetrecom/favourite/{0}',
}

export enum twoFAEnum {
  verify_2fa = '/apirest/portal/client/otp/{0}/device/{1}/verify', //processId deviceId
  resendcode_2fa = '/apirest/portal/client/otp/{0}/new', //processId
}
